import React, { useEffect, useState } from "react";
import { MdAccessTimeFilled, MdFactCheck } from "react-icons/md";

import HoursManagementTable from "./components/HoursManagementTable";
import api from "../../../services/axios";
import SkeletonTable from "../../../components/skeleton/table";

const HoursManagement = () => {
  const [hourData, setHourData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;

  useEffect(() => {
    setLoading(true);
    api
      .get(
        `TimeManagement/GetAdminWorkedHours?month=${currentMonth}&year=${currentYear}`
      )
      .then((response) => {
        setHourData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoading(true);
      });
  }, [currentMonth, currentYear]);

  const columns = [
    { key: "nmEmployee", header: "Colaborador" },
    { key: "nmCorporate", header: "Cliente" },
    { key: "totalHours", header: "Total de horas" },
    { key: "nmProject", header: "Projeto" },
  ];

  return (
    <div className="mt-5 animate-fade-up">
      {/* ── Cabeçalho ─────────────────────────────────────────────────────── */}
      <div className="mb-5 flex items-center gap-4">
        <span
          className="dv-aura flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-dv-gradient text-white shadow-dv-glow"
          aria-hidden="true"
        >
          <MdAccessTimeFilled className="h-6 w-6" />
        </span>
        <div className="min-w-0">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-dv-blue-500/10 px-3 py-1 font-display text-xs font-bold uppercase tracking-[0.18em] text-dv-blue-600 dark:text-dv-cyan-300">
            <MdFactCheck className="h-3.5 w-3.5" aria-hidden="true" />
            Gestão de horas
          </span>
          <h1 className="mt-1.5 text-2xl font-extrabold tracking-tight text-navy-700 dark:text-white">
            Aprovação de apontamentos
          </h1>
        </div>
      </div>

      {loading ? (
        <SkeletonTable active={loading} />
      ) : (
        <HoursManagementTable columns={columns} data={hourData} />
      )}
    </div>
  );
};

export default HoursManagement;
